import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  UntypedFormControl,
  ControlContainer,
  ValidationErrors,
  AbstractControl,
  ValidatorFn,
} from '@angular/forms';
import { ViewEncapsulation } from '@angular/core';
import { cloneDeep } from 'lodash';
import { UtilityService } from 'src/app/shared/services/utility.service';

@Component({
  selector: 'app-registration-securityquestions',
  template: `<div id="regSecurityQuesionsForm">
    <form
      role="none"
      f
      class=""
      [formGroup]="regSecurityQuesionsForm"
      autocomplete="off"
    >
      <ul class="" role="none">
        <div class="mt-20 mb-20">
          <label
            >For security purposes we are asking you to select a series of
            challenge questions.</label
          ><br aria-hidden="true" />
          <label
            >They will be used to provide you with access if you forget your
            password.</label
          >
        </div>

        <li role="none">
          <label for="securityQuestion1">Security Question: *</label>
          <mat-form-field [@.disabled]="animationsDisabled">
            <mat-select
              formControlName="securityQuestion1"
              id="securityQuestion1"
              aria-label="Security question 1 of 5"
              required
              (selectionChange)="updateAvailableQuestions($event)"
            >
              <mat-option
                *ngFor="let question of securityQuestions1"
                [value]="question.Text"
              >
                {{ question.Text }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                regSecurityQuesionsForm.get('securityQuestion1').invalid &&
                regSecurityQuesionsForm.get('securityQuestion1').errors &&
                (regSecurityQuesionsForm.get('securityQuestion1').dirty ||
                  regSecurityQuesionsForm.get('securityQuestion1').touched)
              "
            >
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityQuestion1')
                    .hasError('required')
                "
              >
                <span> Error : Security question 1 of 5 is required.</span>
              </mat-error>
            </mat-error>
          </mat-form-field>
        </li>
        <li role="none">
          <label for="securityAnswer1">Enter your answer: *</label>
          <mat-form-field [@.disabled]="animationsDisabled">
            <input
              matInput
              class="input"
              formControlName="securityAnswer1"
              name="securityAnswer1"
              required
              id="securityAnswer1"
              autocomplete="new-password"
              aria-label="Security answer 1 of 5"
              [type]="hide ? 'password' : 'text'"
            />
            <mat-error
              *ngIf="
                regSecurityQuesionsForm.get('securityAnswer1').invalid &&
                regSecurityQuesionsForm.get('securityAnswer1').errors &&
                (regSecurityQuesionsForm.get('securityAnswer1').dirty ||
                  regSecurityQuesionsForm.get('securityAnswer1').touched)
              "
            >
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityAnswer1')
                    .hasError('required')
                "
              >
                <span> Error : Four or more characters are required.</span>
              </mat-error>
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityAnswer1')
                    .hasError('pattern')
                "
              >
                <span> Error : Please enter a valid Answer.</span>
              </mat-error>
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityAnswer1')
                    .hasError('duplicateAnswer')
                "
              >
                <span> Error : Please enter unique answers.</span>
              </mat-error>
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityAnswer1')
                    .hasError('minlength')
                "
              >
                <span> Error : Four or more characters are required.</span>
              </mat-error>
            </mat-error>
          </mat-form-field>
        </li>
        <mat-divider class="mat-divider"></mat-divider>
        <li role="none">
          <label for="securityQuestion2">Security Question: *</label>
          <mat-form-field [@.disabled]="animationsDisabled">
            <mat-select
              formControlName="securityQuestion2"
              id="securityQuestion2"
              aria-label="Security question 2 of 5"
              required
              (selectionChange)="updateAvailableQuestions($event)"
            >
              <mat-option
                *ngFor="let question of securityQuestions2"
                [value]="question.Text"
              >
                {{ question.Text }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                regSecurityQuesionsForm.get('securityQuestion2').invalid &&
                regSecurityQuesionsForm.get('securityQuestion2').errors &&
                (regSecurityQuesionsForm.get('securityQuestion2').dirty ||
                  regSecurityQuesionsForm.get('securityQuestion2').touched)
              "
            >
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityQuestion2')
                    .hasError('required')
                "
              >
                <span> Error : Security question 2 of 5 is required.</span>
              </mat-error>
            </mat-error>
          </mat-form-field>
        </li>
        <li role="none">
          <label for="securityAnswer2">Enter your answer: *</label>
          <mat-form-field [@.disabled]="animationsDisabled">
            <input
              matInput
              class="input"
              formControlName="securityAnswer2"
              name="securityAnswer2"
              required
              id="securityAnswer2"
              autocomplete="new-password"
              aria-label="Security answer 2 of 5"
              [type]="hide ? 'password' : 'text'"
            />
            <mat-error
              *ngIf="
                regSecurityQuesionsForm.get('securityAnswer2').invalid &&
                regSecurityQuesionsForm.get('securityAnswer2').errors &&
                (regSecurityQuesionsForm.get('securityAnswer2').dirty ||
                  regSecurityQuesionsForm.get('securityAnswer2').touched)
              "
            >
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityAnswer2')
                    .hasError('required')
                "
              >
                <span> Error : Four or more characters are required.</span>
              </mat-error>
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityAnswer2')
                    .hasError('pattern')
                "
              >
                <span> Error : Please enter a valid Answer.</span>
              </mat-error>
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityAnswer2')
                    .hasError('duplicateAnswer')
                "
              >
                <span> Error : Please enter unique answers.</span>
              </mat-error>
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityAnswer2')
                    .hasError('minlength')
                "
              >
                <span> Error : Four or more characters are required.</span>
              </mat-error>
            </mat-error>
          </mat-form-field>
        </li>
        <mat-divider class="mat-divider"></mat-divider>
        <li role="none">
          <label for="securityQuestion3">Security Question: *</label>
          <mat-form-field>
            <mat-select
              class=""
              formControlName="securityQuestion3"
              id="securityQuestion3"
              aria-label="Security question 3 of 5"
              required
              (selectionChange)="updateAvailableQuestions($event)"
            >
              <mat-option
                *ngFor="let question of securityQuestions3"
                [value]="question.Text"
              >
                {{ question.Text }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                regSecurityQuesionsForm.get('securityQuestion3').invalid &&
                regSecurityQuesionsForm.get('securityQuestion3').errors &&
                (regSecurityQuesionsForm.get('securityQuestion3').dirty ||
                  regSecurityQuesionsForm.get('securityQuestion3').touched)
              "
            >
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityQuestion3')
                    .hasError('required')
                "
              >
                <span> Error : Security question 3 of 5 is required.</span>
              </mat-error>
            </mat-error>
          </mat-form-field>
        </li>
        <li role="none">
          <label for="securityAnswer3">Enter your answer: *</label>
          <mat-form-field [@.disabled]="animationsDisabled">
            <input
              matInput
              class="input"
              formControlName="securityAnswer3"
              name="securityAnswer3"
              required
              id="securityAnswer3"
              autocomplete="new-password"
              aria-label="Security answer 3 of 5"
              [type]="hide ? 'password' : 'text'"
            />
            <mat-error
              *ngIf="
                regSecurityQuesionsForm.get('securityAnswer3').invalid &&
                regSecurityQuesionsForm.get('securityAnswer3').errors &&
                (regSecurityQuesionsForm.get('securityAnswer3').dirty ||
                  regSecurityQuesionsForm.get('securityAnswer3').touched)
              "
            >
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityAnswer3')
                    .hasError('required')
                "
              >
                <span> Error : Four or more characters are required.</span>
              </mat-error>
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityAnswer3')
                    .hasError('pattern')
                "
              >
                <span> Error : Please enter a valid Answer.</span>
              </mat-error>
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityAnswer3')
                    .hasError('duplicateAnswer')
                "
              >
                <span> Error : Please enter unique answers.</span>
              </mat-error>
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityAnswer3')
                    .hasError('minlength')
                "
              >
                <span> Error : Four or more characters are required.</span>
              </mat-error>
            </mat-error>
          </mat-form-field>
        </li>
        <mat-divider class="mat-divider"></mat-divider>
        <li role="none">
          <label for="securityQuestion4">Security Question: *</label>
          <mat-form-field [@.disabled]="animationsDisabled">
            <mat-select
              class=""
              formControlName="securityQuestion4"
              id="securityQuestion4"
              aria-label="Security question 4 of 5"
              required
              (selectionChange)="updateAvailableQuestions($event)"
            >
              <mat-option
                *ngFor="let question of securityQuestions4"
                [value]="question.Text"
              >
                {{ question.Text }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                regSecurityQuesionsForm.get('securityQuestion4').invalid &&
                regSecurityQuesionsForm.get('securityQuestion4').errors &&
                (regSecurityQuesionsForm.get('securityQuestion4').dirty ||
                  regSecurityQuesionsForm.get('securityQuestion4').touched)
              "
            >
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityQuestion4')
                    .hasError('required')
                "
              >
                <span> Error : Security question 4 of 5 is required.</span>
              </mat-error>
            </mat-error>
          </mat-form-field>
        </li>
        <li role="none">
          <label for="securityAnswer4">Enter your answer: *</label>
          <mat-form-field [@.disabled]="animationsDisabled">
            <input
              matInput
              class="input"
              formControlName="securityAnswer4"
              name="securityAnswer4"
              required
              id="securityAnswer4"
              autocomplete="new-password"
              aria-label="Security answer 4 of 5"
              [type]="hide ? 'password' : 'text'"
            />
            <mat-error
              *ngIf="
                regSecurityQuesionsForm.get('securityAnswer4').invalid &&
                regSecurityQuesionsForm.get('securityAnswer4').errors &&
                (regSecurityQuesionsForm.get('securityAnswer4').dirty ||
                  regSecurityQuesionsForm.get('securityAnswer4').touched)
              "
            >
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityAnswer4')
                    .hasError('required')
                "
              >
                <span> Error : Four or more characters are required.</span>
              </mat-error>
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityAnswer4')
                    .hasError('pattern')
                "
              >
                <span> Error : Please enter a valid Answer.</span>
              </mat-error>
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityAnswer4')
                    .hasError('duplicateAnswer')
                "
              >
                <span> Error : Please enter unique answers.</span>
              </mat-error>
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityAnswer4')
                    .hasError('minlength')
                "
              >
                <span> Error : Four or more characters are required.</span>
              </mat-error>
            </mat-error>
          </mat-form-field>
        </li>
        <mat-divider class="mat-divider"></mat-divider>
        <li role="none">
          <label for="securityQuestion5">Security Question: *</label>
          <mat-form-field [@.disabled]="animationsDisabled">
            <mat-select
              class=""
              formControlName="securityQuestion5"
              id="securityQuestion5"
              aria-label="Security question 5 of 5"
              required
              (selectionChange)="updateAvailableQuestions($event)"
            >
              <mat-option
                *ngFor="let question of securityQuestions5"
                [value]="question.Text"
              >
                {{ question.Text }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                regSecurityQuesionsForm.get('securityQuestion5').invalid &&
                regSecurityQuesionsForm.get('securityQuestion5').errors &&
                (regSecurityQuesionsForm.get('securityQuestion5').dirty ||
                  regSecurityQuesionsForm.get('securityQuestion5').touched)
              "
            >
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityQuestion5')
                    .hasError('required')
                "
              >
                <span> Error : Security question 5 of 5 is required.</span>
              </mat-error>
            </mat-error>
          </mat-form-field>
        </li>
        <li role="none">
          <label for="securityAnswer5">Enter your answer: *</label>
          <mat-form-field [@.disabled]="animationsDisabled">
            <input
              matInput
              class="input"
              formControlName="securityAnswer5"
              name="securityAnswer5"
              required
              id="securityAnswer5"
              autocomplete="new-password"
              aria-label="Security answer 5 of 5"
              [type]="hide ? 'password' : 'text'"
            />
            <mat-error
              *ngIf="
                regSecurityQuesionsForm.get('securityAnswer5').invalid &&
                regSecurityQuesionsForm.get('securityAnswer5').errors &&
                (regSecurityQuesionsForm.get('securityAnswer5').dirty ||
                  regSecurityQuesionsForm.get('securityAnswer5').touched)
              "
            >
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityAnswer5')
                    .hasError('required')
                "
              >
                <span> Error : Four or more characters are required.</span>
              </mat-error>
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityAnswer5')
                    .hasError('pattern')
                "
              >
                <span> Error : Please enter a valid Answer.</span>
              </mat-error>
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityAnswer5')
                    .hasError('duplicateAnswer')
                "
              >
                <span> Error : Please enter unique answers.</span>
              </mat-error>
              <mat-error
                class="error-message"
                *ngIf="
                  regSecurityQuesionsForm
                    .get('securityAnswer5')
                    .hasError('minlength')
                "
              >
                <span> Error : Four or more characters are required.</span>
              </mat-error>
            </mat-error>
          </mat-form-field>
        </li>
      </ul>

      <ul role="none" class="secAnswers-checkbox">
        <label id="chkShowPassword">{{ displayLabel }}</label>
        <mat-checkbox
          aria-labelledby="chkShowPassword"
          labelPosition="before"
          color="primary"
          (change)="showHideAnswers()"
        ></mat-checkbox>
      </ul>
    </form>
  </div> `,
  styles: [
    `
      .registrationContent {
        margin: 40px;
      }

      .registration-toast {
        background-color: var(--dark-blue);
        color: white;
        max-width: 600px;
      }

      .registration-container {
        width: 80%;
        max-width: 630px;
        margin: 30px;
      }

      .registration-container * {
        box-sizing: border-box;
      }

      .mat-select-underline {
        border-bottom: 1px solid var(--dark-blue);
      }

      .reg-icon {
        margin-right: 5%;
        font-size: 21px;
      }
      .mat-radio-button ~ .mat-radio-button {
        margin-left: 16px;
      }

      .secAnswers-checkbox {
        text-align: right;
        margin-top: 5%;
      }
    `,
  ],
  encapsulation: ViewEncapsulation.Emulated,
  animations: [], //if needed trigger conditions here
})
export class RegistrationSecurityquestionsComponent implements OnInit {
  //regSecurityQuesionsForm: FormGroup;
  animationsDisabled = true;
  hide = true;
  displayLabel = 'Show Password';

  @Input() regSecurityQuesionsForm: UntypedFormGroup;
  @Input() hideAnswerLabel: string;
  @Output() private onChangeShowHide = new EventEmitter<any>();

  securityQuestions: { Value: number; Text: string }[] = [
    {
      Value: 0,
      Text: 'What is your favorite dessert?',
    },
    {
      Value: 1,
      Text: 'What is your favorite sports team?',
    },
    {
      Value: 2,
      Text: 'What is your favorite food to eat?',
    },
    {
      Value: 3,
      Text: 'What is your dream job?',
    },
    {
      Value: 4,
      Text: 'In what year was your mother born?',
    },
    {
      Value: 5,
      Text: 'What is the first and last name of your first boyfriend or girlfriend?',
    },
    {
      Value: 6,
      Text: 'Which phone number do you remember most from your childhood?',
    },
    {
      Value: 7,
      Text: 'What was your favorite place to visit as a child?',
    },
    {
      Value: 8,
      Text: 'Who is your favorite actor?',
    },
    {
      Value: 9,
      Text: 'What is the name of your favorite pet?',
    },
    {
      Value: 10,
      Text: 'In what city were you born?',
    },
    {
      Value: 11,
      Text: 'What high school did you attend?',
    },
    {
      Value: 12,
      Text: 'What elementary school did you attend?',
    },
    {
      Value: 13,
      Text: 'What is your favorite movie?',
    },
    {
      Value: 14,
      Text: "What is your mother's maiden name?",
    },
    {
      Value: 15,
      Text: 'What street did you grow up on?',
    },
    {
      Value: 16,
      Text: 'What was the make and model of your first car?',
    },
    {
      Value: 17,
      Text: 'When is your anniversary?',
    },
    {
      Value: 18,
      Text: 'What is your favorite color?',
    },
    {
      Value: 19,
      Text: "What is your father's middle name?",
    },
    {
      Value: 20,
      Text: 'What is the name of your first grade teacher?',
    },
    {
      Value: 21,
      Text: 'What was your high school mascot?',
    },
    {
      Value: 22,
      Text: 'Who was your favorite teacher?',
    },
    {
      Value: 23,
      Text: 'In what city did you meet your spouse/significant other?',
    },
    {
      Value: 24,
      Text: 'What is the name of your best friend from childhood?',
    },
    {
      Value: 25,
      Text: 'What street did you live on in third grade?',
    },
    {
      Value: 26,
      Text: "What is your youngest sibling's birthday month and year?",
    },
    {
      Value: 27,
      Text: 'What is the middle name of your youngest child?',
    },
    {
      Value: 28,
      Text: "What is your youngest sibling's middle name?",
    },
    {
      Value: 29,
      Text: 'What school did you attend for sixth grade?',
    },
    {
      Value: 30,
      Text: "What is your oldest cousin's name?",
    },
    {
      Value: 31,
      Text: 'What was the name of your first stuffed animal?',
    },
    {
      Value: 32,
      Text: 'In what city or town did your mother and father meet?',
    },
    {
      Value: 33,
      Text: 'Who is your favorite musician?',
    },
    {
      Value: 34,
      Text: 'What was the last name of your first grade teacher?',
    },
    {
      Value: 35,
      Text: 'In what city does your nearest sibling live?',
    },
    {
      Value: 36,
      Text: "What is your oldest sibling's birthday month and year?",
    },
    {
      Value: 37,
      Text: "What is your maternal grandmother's maiden name?",
    },
    {
      Value: 38,
      Text: 'In what city or town was your first job?',
    },
    {
      Value: 39,
      Text: 'Where was your wedding reception held?',
    },
    {
      Value: 40,
      Text: "What is the name of a college you applied to but didn't attend?",
    },
    {
      Value: 41,
      Text: 'Where were you when you first heard about 9/11?',
    },
    {
      Value: 42,
      Text: 'Who is your favorite super hero?',
    },
    {
      Value: 43,
      Text: 'What was the first concert you attended?',
    },
    {
      Value: 44,
      Text: 'What is the name of your favorite book?',
    },
  ];

  securityQuestions1 = cloneDeep(this.securityQuestions);
  securityQuestions2 = cloneDeep(this.securityQuestions);
  securityQuestions3 = cloneDeep(this.securityQuestions);
  securityQuestions4 = cloneDeep(this.securityQuestions);
  securityQuestions5 = cloneDeep(this.securityQuestions);

  constructor(
    private fb: UntypedFormBuilder,
    private utility: UtilityService
  ) {}

  ngOnInit() {
    this.createSecurityQuesForm();
    if (!this.utility.isNullOrEmpty(this.hideAnswerLabel))
      this.displayLabel = this.hideAnswerLabel;
  }

  createSecurityQuesForm() {
    //This component should be its own form group, it should not be addeding all these individual controls to the
    //parent form group.
    this.regSecurityQuesionsForm.addControl(
      'securityQuestion1',
      new UntypedFormControl('', [Validators.required])
    );
    this.regSecurityQuesionsForm.addControl(
      'securityQuestion2',
      new UntypedFormControl('', [Validators.required])
    );
    this.regSecurityQuesionsForm.addControl(
      'securityQuestion3',
      new UntypedFormControl('', [Validators.required])
    );
    this.regSecurityQuesionsForm.addControl(
      'securityQuestion4',
      new UntypedFormControl('', [Validators.required])
    );
    this.regSecurityQuesionsForm.addControl(
      'securityQuestion5',
      new UntypedFormControl('', [Validators.required])
    );

    this.regSecurityQuesionsForm.addControl(
      'securityAnswer1',
      new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9_ $@$#!%^+=&]*$'),
        Validators.minLength(4),
        this.checkDuplicateAnswer1.bind(this),
      ])
    );
    this.regSecurityQuesionsForm.addControl(
      'securityAnswer2',
      new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9_ $@$#!%^+=&]*$'),
        Validators.minLength(4),
        this.checkDuplicateAnswer2.bind(this),
      ])
    );
    this.regSecurityQuesionsForm.addControl(
      'securityAnswer3',
      new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9_ $@$#!%^+=&]*$'),
        Validators.minLength(4),
        this.checkDuplicateAnswer3.bind(this),
      ])
    );
    this.regSecurityQuesionsForm.addControl(
      'securityAnswer4',
      new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9_ $@$#!%^+=&]*$'),
        Validators.minLength(4),
        this.checkDuplicateAnswer4.bind(this),
      ])
    );
    this.regSecurityQuesionsForm.addControl(
      'securityAnswer5',
      new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9_ $@$#!%^+=&]*$'),
        Validators.minLength(4),
        this.checkDuplicateAnswer5.bind(this),
      ])
    );
  }

  updateAvailableQuestions(e) {
    this.securityQuestions1 = this.securityQuestions.filter(
      (q) =>
        q.Text !==
          e.source._parentFormGroup.form.get('securityQuestion2').value &&
        q.Text !==
          e.source._parentFormGroup.form.get('securityQuestion3').value &&
        q.Text !==
          e.source._parentFormGroup.form.get('securityQuestion4').value &&
        q.Text !== e.source._parentFormGroup.form.get('securityQuestion5').value
    );
    this.securityQuestions2 = this.securityQuestions.filter(
      (q) =>
        q.Text !==
          e.source._parentFormGroup.form.get('securityQuestion1').value &&
        q.Text !==
          e.source._parentFormGroup.form.get('securityQuestion3').value &&
        q.Text !==
          e.source._parentFormGroup.form.get('securityQuestion4').value &&
        q.Text !== e.source._parentFormGroup.form.get('securityQuestion5').value
    );
    this.securityQuestions3 = this.securityQuestions.filter(
      (q) =>
        q.Text !==
          e.source._parentFormGroup.form.get('securityQuestion1').value &&
        q.Text !==
          e.source._parentFormGroup.form.get('securityQuestion2').value &&
        q.Text !==
          e.source._parentFormGroup.form.get('securityQuestion4').value &&
        q.Text !== e.source._parentFormGroup.form.get('securityQuestion5').value
    );
    this.securityQuestions4 = this.securityQuestions.filter(
      (q) =>
        q.Text !==
          e.source._parentFormGroup.form.get('securityQuestion1').value &&
        q.Text !==
          e.source._parentFormGroup.form.get('securityQuestion3').value &&
        q.Text !==
          e.source._parentFormGroup.form.get('securityQuestion2').value &&
        q.Text !== e.source._parentFormGroup.form.get('securityQuestion5').value
    );
    this.securityQuestions5 = this.securityQuestions.filter(
      (q) =>
        q.Text !==
          e.source._parentFormGroup.form.get('securityQuestion1').value &&
        q.Text !==
          e.source._parentFormGroup.form.get('securityQuestion3').value &&
        q.Text !==
          e.source._parentFormGroup.form.get('securityQuestion4').value &&
        q.Text !== e.source._parentFormGroup.form.get('securityQuestion2').value
    );
  }

  // checkDuplicateAnswer1(fc: UntypedFormControl): Validators {
  //   if (fc.value && (fc.value === this.regSecurityQuesionsForm.get('securityAnswer2').value || fc.value === this.regSecurityQuesionsForm.get('securityAnswer3').value || fc.value === this.regSecurityQuesionsForm.get('securityAnswer4').value
  //     || fc.value === this.regSecurityQuesionsForm.get('securityAnswer5').value)) {
  //     return { duplicateAnswer: true }
  //   }
  //   else {
  //     this.checkAllOtherAnswers(1);
  //   }
  // }

  // checkDuplicateAnswer2(fc: UntypedFormControl): Validators {
  //   if (fc.value && (fc.value === this.regSecurityQuesionsForm.get('securityAnswer1').value || fc.value === this.regSecurityQuesionsForm.get('securityAnswer3').value || fc.value === this.regSecurityQuesionsForm.get('securityAnswer4').value
  //     || fc.value === this.regSecurityQuesionsForm.get('securityAnswer5').value)) {
  //     return { duplicateAnswer: true }
  //   }
  //   else {
  //     this.checkAllOtherAnswers(2);
  //   }
  // }

  // checkDuplicateAnswer3(fc: UntypedFormControl): Validators {
  //   if (fc.value && (fc.value === this.regSecurityQuesionsForm.get('securityAnswer2').value || fc.value === this.regSecurityQuesionsForm.get('securityAnswer1').value || fc.value === this.regSecurityQuesionsForm.get('securityAnswer4').value
  //     || fc.value === this.regSecurityQuesionsForm.get('securityAnswer5').value)) {
  //     return { duplicateAnswer: true }
  //   }
  //   else {
  //     this.checkAllOtherAnswers(3);
  //   }
  // }

  // checkDuplicateAnswer4(fc: UntypedFormControl): Validators {
  //   if (fc.value && (fc.value === this.regSecurityQuesionsForm.get('securityAnswer2').value || fc.value === this.regSecurityQuesionsForm.get('securityAnswer3').value || fc.value === this.regSecurityQuesionsForm.get('securityAnswer1').value
  //     || fc.value === this.regSecurityQuesionsForm.get('securityAnswer5').value)) {
  //     return { duplicateAnswer: true }
  //   }
  //   else {
  //     this.checkAllOtherAnswers(4);
  //   }
  // }

  // checkDuplicateAnswer5(fc: UntypedFormControl): Validators {
  //   if (fc.value && (fc.value === this.regSecurityQuesionsForm.get('securityAnswer2').value || fc.value === this.regSecurityQuesionsForm.get('securityAnswer3').value || fc.value === this.regSecurityQuesionsForm.get('securityAnswer4').value
  //     || fc.value === this.regSecurityQuesionsForm.get('securityAnswer1').value)) {
  //     return { duplicateAnswer: true }
  //   }
  //   else {
  //     this.checkAllOtherAnswers(5);
  //   }
  // }

  private createDuplicateAnswerValidator(answerNumber: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }

      const otherAnswers = [1, 2, 3, 4, 5]
        .filter((num) => num !== answerNumber)
        .map(
          (num) =>
            this.regSecurityQuesionsForm.get(`securityAnswer${num}`)?.value
        );

      const isDuplicate = otherAnswers.some(
        (answer) => answer === control.value
      );

      if (isDuplicate) {
        this.checkAllOtherAnswers(answerNumber);
        return { duplicateAnswer: true };
      }

      this.checkAllOtherAnswers(answerNumber);
      return null;
    };
  }

  checkDuplicateAnswer1(): ValidatorFn {
    return this.createDuplicateAnswerValidator(1);
  }

  checkDuplicateAnswer2(): ValidatorFn {
    return this.createDuplicateAnswerValidator(2);
  }

  checkDuplicateAnswer3(): ValidatorFn {
    return this.createDuplicateAnswerValidator(3);
  }

  checkDuplicateAnswer4(): ValidatorFn {
    return this.createDuplicateAnswerValidator(4);
  }

  checkDuplicateAnswer5(): ValidatorFn {
    return this.createDuplicateAnswerValidator(5);
  }

  showHideAnswers(): void {
    this.hide = this.hide ? false : true;
    this.onChangeShowHide.emit(this.hide);
  }

  getSecurityAnswer(answerNumber: number) {
    return this.regSecurityQuesionsForm.get(`securityAnswer${answerNumber}`);
  }

  allAnswersSupplied(): boolean {
    return !(
      this.utility.isNullOrEmpty(this.getSecurityAnswer(1)?.value) ||
      this.utility.isNullOrEmpty(this.getSecurityAnswer(2)?.value) ||
      this.utility.isNullOrEmpty(this.getSecurityAnswer(3)?.value) ||
      this.utility.isNullOrEmpty(this.getSecurityAnswer(4)?.value) ||
      this.utility.isNullOrEmpty(this.getSecurityAnswer(5)?.value)
    );
  }

  checkAllOtherAnswers(currentQuestion: number): void {
    if (this.allAnswersSupplied()) {
      for (let i = 1; i < 6; i++) {
        if (i === currentQuestion) continue;

        const secAnswer = this.getSecurityAnswer(i);
        if (secAnswer.hasError('duplicateAnswer'))
          secAnswer?.updateValueAndValidity();
      }
    }
  }
}
